import { getConfig } from "@components/Config";

type ApiSandbox = {
  investorUrl?: string;
  backstageUrl?: string;
};

type Props = {
  organizationId?: string;
  isConsoleOperator: boolean;
};

// NOTE: the sandbox is the Swagger UI app of the API. The console app serves
//       each organization of the environment, therefore the config holds one
//       address for it. The app of the back office is an app of one
//       organization, therefore the config holds an address for each
//       organization that has one.
const getApiSandboxUrl = ({
  organizationId,
  isConsoleOperator,
}: Props): string | undefined => {
  if (isConsoleOperator) {
    const consoleUrl = getConfig("CONSOLE_API_SANDBOX_URL") as string;
    const hasConsoleUrl = !!consoleUrl;

    if (!hasConsoleUrl) {
      return undefined;
    }

    return consoleUrl;
  }

  const hasOrganizationId = !!organizationId;

  if (!hasOrganizationId) {
    return undefined;
  }

  const sandboxes = getConfig("API_SANDBOXES") as Record<string, ApiSandbox>;
  const sandbox = sandboxes[organizationId];
  const hasSandbox = !!sandbox;

  if (!hasSandbox) {
    return undefined;
  }

  const { backstageUrl } = sandbox;

  return backstageUrl;
};

export default getApiSandboxUrl;
